"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparisonRecipe = void 0;
function comparisonRecipe({ count, take, resolver, comparer, }) {
    return function (expectedSize) {
        const counted = count.call(take.call(this, expectedSize + 1));
        return resolver(counted, comparer(expectedSize));
    };
}
exports.comparisonRecipe = comparisonRecipe;
